import HearroSdk from '@hearro/hearro-sdk'
import Vue from 'vue'
import * as _ from 'lodash'

const hearrosdk = new HearroSdk({
  api: {
    httpEndpoint: process.env.VUE_APP_HEARRO_API,
    subscriptionsUri: process.env.VUE_APP_HEARRO_API_SUBSCRIPTIONS
  },
  orgId: process.env.VUE_APP_HEARRO_ORG_ID
})

/*

Actions

*/
async function resolveDid (_, { did }) {
  try {
    const message = {}
    message['@type'] = 'https://hearro.com/protocols/1.0/did-resolve'
    message.did = did
    return await hearrosdk.rawMessage(message)
  } catch (e) {
    throw new Error(`could not resolve did (${e.message})`)
  }
}

async function createUser (_, { email, password, first, last }) {
  try {
    await hearrosdk.createUser({ email, password, first, last })
  } catch (e) {
    throw new Error(`Could not create HearRo User (${e.message})`)
  }
}

async function loginUser ({ commit }, { email, password, openWallet }) {
  try {
    await hearrosdk.login({ email, password })
    const { user, diddoc, walletOpen } = hearrosdk.loggedInUser();
    commit('setUser', { user, diddoc, walletOpen })
    if (openWallet) {
      await hearrosdk.openWallet({ password })
      commit('setUser', { user, diddoc, walletOpen: true })
    }
  } catch (e) {
    throw new Error(`Could not login HearRo User (${e.message})`)
  }
}

async function logout ({ commit }) {
  try {
    hearrosdk.logOutUser()
    window.location.reload(true)
  } catch (e) {
    throw new Error(`Could not logout HearRo User (${e.message})`)
  }
}

async function getConnections ({ commit }) {
  try {
    const connections = await hearrosdk.connections()
    commit('setConnections', { connections })
  } catch (e) {
    throw new Error(`Counld not get HearRo Connections (${e.message}`)
  }
}

async function getInvites ({ commit }) {
  try {
    const invites = await hearrosdk.invites()
    commit('setInvites', { invites })
  } catch (e) {
    throw new Error(`Counld not get HearRo invitations (${e.message}`)
  }
}

async function sendInvite (_, { invitee }) {
  try {
    await hearrosdk.sendInvite({ invitee })
  } catch (e) {
    throw new Error(`Could not send HearRo invite (${e.message}`)
  }
}

async function acceptInvite ({ dispatch }, { id }) {
  try {
    await hearrosdk.acceptInvite({ id })
    dispatch('getInvites')
  } catch (e) {
    throw new Error(`Unable to accept invite (${e.message})`)
  }
}

async function connectItem ({ dispatch }, { did }) {
  try {
    const message = {}
    message['@type'] = 'https://hearro.com/protocols/1.0/connection-thing'
    message.invitee = did
    const reply = await hearrosdk.rawMessage(message)
    console.log('connect thing reply', reply)
    dispatch('getConnections')
  } catch (e) {
    throw new Error(`Unable to accept invite (${e.message})`)
  }
}

async function newConversation (_, { label, participants }) {
  try {
    const { id } = await hearrosdk.newConversation(label, participants)
    return id
  } catch (e) {
    throw new Error(`Unable to create conversation (${e.message})`)
  }
}

async function addConversationParticipant (_, { conversationId, participantDid }) {
  try {
    await hearrosdk.addConversationParticipant({ conversationId, participantDid })
  } catch (e) {
    throw new Error(`Unable to add conversation participant (${e.message})`)
  }
}

async function sendConversationInvite (_, { invitee, message, conversationId }) {
  try {
    await hearrosdk.sendConversationInvite({ invitee, message, conversationId })
  } catch (e) {
    throw new Error(`Could not send HearRo invite (${e.message}`)
  }
}

async function acceptConversationInvite ({ dispatch }, { id }) {
  try {
    await hearrosdk.acceptConversationInvite({ id })
    dispatch('loadConversationInvites')
  } catch (e) {
    throw new Error(`Unable to accept invite (${e.message})`)
  }
}

async function loadConversations ({ commit }) {
  try {
    const conversations = await hearrosdk.conversations()
    const conversationModel = []
    conversations.forEach(async c => {
      const participants = await hearrosdk.conversationParticipants(c.data.id)
      const messages = await hearrosdk.loadConversationMessages({ conversationId: c.data.id, page: 1, pageSize: 20 })
      const items = await hearrosdk.conversationItems({ conversationId: c.data.id })
      const newC = {
        ...c,
        participants,
        messages,
        subscription: {},
        items
      }
      conversationModel.push(newC)
    })
    commit('setConversations', { conversations: conversationModel })
  } catch (e) {
    throw new Error(`Counld not get HearRo conversations (${e.message}`)
  }
}

async function loadConversationParticipants ({ commit }, { conversationId }) {
  try {
    const participants = await hearrosdk.conversationParticipants(conversationId)
    // commit('setConversationParticipants', { participants })
    return participants
  } catch (e) {
    throw new Error(`Counld not get HearRo conversation participants (${e.message}`)
  }
}

async function loadConversationInvites ({ commit }) {
  try {
    const invites = await hearrosdk.conversationInvites()
    commit('setConversationInvites', { invites })
  } catch (e) {
    throw new Error(`Counld not get HearRo invitations (${e.message}`)
  }
}

async function subscribeConversationMessageStream ({ dispatch, state, commit }, { conversationId }) {
  console.log('subscribing to message stream', conversationId)
  try {
    if (state.conversationSubscription && state.conversationSubscription.subscription) {
      console.log('unsubscribing from message stream')
      await state.conversationSubscription.subscription.unsubscribe()
    }
    const subscription = await hearrosdk.subscribeConversationMessages({ conversationId })

    subscription.subscribe({
      next ({ message }) {
        console.log('vuex subscription message received', message)
        commit('addConversationMessage', { conversationId, message })
      },
      error (err) {
        console.log('error receiving data from subscription', err.message)
      }
    })

    commit('setConversationMessageStream', { conversationId, subscription })
    return subscription
  } catch (e) {
    console.log('subscription error:', e)
    throw new Error(`Counld not subscribe to HearRo conversation (${e.message}`)
  }
}

async function unsubscribeFromMessageStream ({ commit }, { conversationId }) {
  console.log('unsubscribe message stream', conversationId)
  try {
    commit('closeConversationSubscription', { conversationId })
  } catch (e) {
    console.log('trouble unsubscribing from conversation message stream', conversationId)
  }
}

async function sendConversationMessage (_, { conversationId, body }) {
  try {
    await hearrosdk.conversationMessage({ conversationId, body })
  } catch (e) {
    console.log('trouble unsubscribing from conversation message stream', conversationId)
  }
}

async function loadConversationMessages ({ commit }, { conversationId, page, pageSize }) {
  console.log('load conversation messages')
  try {
    const messages = await hearrosdk.loadConversationMessages({ conversationId, page, pageSize })
    // commit('conversationMessages', { conversationId })
    return messages
  } catch (e) {
    console.log('unable to load conversation messages', e)
  }
}

async function loadConversationItems ({ commit }, { conversationId }) {
  console.log('load conversation messages')
  try {
    const items = await hearrosdk.conversationItems({ conversationId })
    commit('setConversationItems', { conversationId, items })
    return items
  } catch (e) {
    console.log('unable to load conversation messages', e)
  }
}

async function createConversationItem ({ commit }, { conversationId, name, size, mimeType }) {
  console.log('create item')
  try {
    const response = await hearrosdk.createConversationItem({ conversationId, name, size, mimeType })
    console.log('create item response', response)
    await commit('setConversationItemsUpload', { itemId: response.id })
  } catch (e) {
    console.log('unable to create conversation item', e)
  }
}

async function saveConversationItemData ({ commit, dispatch }, { conversationId, file }) {
  console.log('save item data')
  try {
    const response = await hearrosdk.createConversationItem({ conversationId, name: file.name, size: file.size, mimeType: file.type })
    console.log('create item response', response, commit)
    await commit('setConversationItemsUpload', { itemId: response.id, add: true })
    await dispatch('loadConversationItems', { conversationId })
    const uploadResponse = await hearrosdk.saveConversationItemData({ conversationId, file, itemId: response.id })
    console.log('uploadResponse', uploadResponse)
    await commit('setConversationItemsUpload', { itemId: response.id, add: false })
    await dispatch('loadConversationItems', { conversationId })
  } catch (e) {
    console.log('unable to save conversation item', e.message)
  }
}

async function deleteConversationItem (_, { conversationId, itemId }) {
  try {
    const response = await hearrosdk.deleteConversationItem({ conversationId, itemId })
    console.log(response)
  } catch (e) {
    console.log('unable to delete conversation item', e)
  }
}

async function newRTCSession (_, { conversationId }) {
  try {
    await hearrosdk.newRTCSession({ conversationId })
  } catch (e) {
    console.log('unable to create RTC Session', e.message)
  }
}

async function getRTCSession ({ commit }, { conversationId, sessionId }) {
  console.log('get rtc session', conversationId, sessionId)
  try {
    const response = await hearrosdk.getRTCSession({ conversationId, sessionId })
    console.log('getrtcsession', response)
    await commit('setCoversationRTCSession', { conversationId, rtcSession: response })
  } catch (e) {
    console.log('unable to get RTC Session', e.message)
  }
}

async function joinRTCSession ({ commit }, { conversationId, sessionId }) {
  console.log('join rtc session', conversationId, sessionId)
  try {
    const peerConnection = await hearrosdk.joinRTCSession({ conversationId, sessionId })
    await commit('setRTCSession', { conversationId, sessionId, peerConnection })
  } catch (e) {
    console.log('unable to get RTC Session', e.message)
  }
}

async function negotiateRTCSession ({ commit }, { conversationId, sessionId, offer }) {
  console.log('negotiate rtc session', conversationId, sessionId)
  try {
    const reply = await hearrosdk.negotiateRTCSession({ conversationId, sessionId, offer })
    await commit('setRTCSession', { conversationId, sessionId, reply })
    return reply
  } catch (e) {
    console.log('unable to get RTC Session', e.message)
  }
}

// Getters - pull information from the store
/*

 Getters

 */

async function userExists (email) {
  try {
    const res = await hearrosdk.emailExists(email)
    const id = _.get(res, 'user.id')

    return id
  } catch (e) {
    throw new Error('error accessing the hearro api', e)
  }
}

function loggedInUser (state) {
  return { user: state.user, diddoc: state.diddoc, walletOpen: state.walletOpen }
}

function connections (state) {
  return state.connections
}

function invites (state) {
  return state.invites
}

function conversations (state) {
  return state.conversations
}

function conversationMessages (state) {
  return function ({ conversationId }) {
    const cid = state.conversations.findIndex(c => {
      return c.data.id === conversationId
    })
    return (state.conversations[cid]) ? state.conversations[cid].messages : []
  }
}

function conversationParticipants (state) {
  return function ({ conversationId }) {
    const cid = state.conversations.findIndex(c => {
      return c.data.id === conversationId
    })
    return (state.conversations[cid]) ? state.conversations[cid].participants : []
  }
}

function conversationItems (state) {
  // return state.conversationItems
  return function (conversationId) {
    const cid = state.conversationItems.findIndex(c => {
      return c.conversationId === conversationId
    })
    return (state.conversationItems[cid]) ? state.conversationItems[cid].items : []
  }
}

function conversationInvites (state) {
  return state.conversationInvites
}

function conversationRTCMessage (state) {
  return function (conversationId, sessionId) {
    const cid = state.conversations.findIndex(c => {
      return c.conversationId === conversationId
    })

    if (cid !== -1 && state.conversations[cid].rtcSessions) {
      const cmid = state.conversations[cid].rtcSessions.findIndex(s => {
        return s.id === sessionId
      })
      if (cmid !== -1) {
        return state.conversations[cid].rtcSessions[cmid]
      }
    }

    return {}
  }
}

function rtcSession (state) {
  return state.rtcSession
}

// define mutations - only actions you define should hit mutations (and thus this store)
/*

Mutations

*/
function setUser (state, { user, diddoc, walletOpen }) {
  state.user = user
  state.diddoc = diddoc
  state.walletOpen = walletOpen
}

function setConnections (state, { connections }) {
  state.connections = connections
}

function setInvites (state, { invites }) {
  state.invites = invites
}

function setConversationInvites (state, { invites }) {
  state.conversationInvites = invites
}

function setConversations (state, { conversations }) {
  state.conversations = conversations
}

function setConversationParticipants (state, { participants, conversationId }) {
  const conversationIndex = state.conversations.findIndex(e => {
    return e.data.id === conversationId
  })
  if (conversationIndex !== -1) {
    const newC = state.conversations[conversationIndex]
    newC.participants = participants
    Vue.set(state.conversations, conversationIndex, newC)
  }
}

function setConversationMessageStream (state, { conversationId, subscription }) {
  state.conversationSubscription = { conversationId, subscription }
}

function addConversationMessage (state, { conversationId, message }) {
  const conversationIndex = state.conversations.findIndex(e => {
    return e.data.id === conversationId
  })
  if (conversationIndex !== -1) {
    state.conversations[conversationIndex].messages.push(message)
  }
}

function closeConversationSubscription (state) {
  // if (state.conversationSubscription) {
  //   state.conversationSubscription.unsubscribe()
  // }
  // const conversationIndex = state.conversations.findIndex(e => {
  //   return e.data.id === conversationId
  // })
  // if (conversationIndex !== -1) {
  //   state.conversations[conversationIndex].subscription.unsubscribe()
  //   state.conversations[conversationIndex].subscription = {}
  // }
}

function setConversationItems (state, { conversationId, items }) {
  const cIndex = state.conversations.findIndex(e => {
    return e.data.id === conversationId
  })

  if (cIndex !== -1) {
    items.forEach(i => {
      const itemIndex = state.conversationItemUploads.findIndex(ui => ui === i.id)
      console.log('item index', itemIndex)
      if (itemIndex !== -1) {
        i.uploading = true
      } else {
        i.uploading = false
      }
    })
    state.conversations[cIndex].items = items
  }
}

function setConversationItemsUpload (state, { conversationId, itemId, add }) {
  const itemIndex = state.conversationItemUploads.findIndex(e => e === itemId)
  console.log('set upload', itemId, itemIndex)
  if (itemIndex === -1 && add) {
    console.log('push item to uploads')
    state.conversationItemUploads.push(itemId)
  }

  if (!add && itemIndex !== -1) {
    state.conversationItemUploads.splice(itemIndex, 1)
  }
}

function setCoversationRTCSession (state, { conversationId, rtcSession }) {
  const cIndex = state.conversations.findIndex(e => {
    return e.data.id === conversationId
  })

  if (cIndex !== -1) {
    const newC = state.conversations[cIndex]
    if (!newC.rtcSessions) {
      newC.rtcSessions = [rtcSession]
    } else {
      // find the index
      const sessionIndex = newC.rtcSessions.findIndex(s => {
        return s.id === rtcSession.id
      })
      if (sessionIndex === -1) {
        newC.rtcSessions.push(rtcSession)
      } else {
        newC.rtcSessions.splice(sessionIndex, 1, rtcSession)
      }
    }

    Vue.set(state.conversations, cIndex, newC)
  }
}

function setRTCSession (state, { conversationId, sessionId, peerConnection, reply }) {
  state.rtcSession = { conversationId, sessionId, peerConnection, reply }
}

function removeRTCSession (state) {
  if (state.rtcSession && state.rtcSession.peerConnection) {
    state.rtcSession.peerConnection.getSenders().forEach(sender => {
      sender.track.stop()
    })
  }
}

function init (state) {
  const { user, diddoc, walletOpen } = hearrosdk.loggedInUser()
  state.user = user
  state.diddoc = diddoc
  state.walletOpen = walletOpen
}

export const HearroVue = {
  namespaced: true,
  state: {
    user: {},
    diddoc: {},
    walletOpen: false,
    conversations: [],
    connections: [],
    invites: [],
    conversationInvites: [],
    conversationItemUploads: [],
    conversationSubscription: {},
    rtcSession: { conversationId: '', sessionId: '', peerConnection: null, reply: null }
  },
  mutations: {
    init: init,
    setUser: setUser,
    setConnections: setConnections,
    setInvites: setInvites,
    setConversationInvites: setConversationInvites,
    setConversations: setConversations,
    setConversationParticipants: setConversationParticipants,
    setConversationMessageStream: setConversationMessageStream,
    addConversationMessage: addConversationMessage,
    closeConversationSubscription: closeConversationSubscription,
    setConversationItems: setConversationItems,
    setConversationItemsUpload: setConversationItemsUpload,
    setCoversationRTCSession: setCoversationRTCSession,
    setRTCSession: setRTCSession,
    removeRTCSession: removeRTCSession
  },
  actions: {
    resolveDid: resolveDid,
    createUser: createUser,
    loginUser: loginUser,
    logout: logout,
    getConnections: getConnections,
    getInvites: getInvites,
    sendInvite: sendInvite,
    acceptInvite: acceptInvite,
    connectItem: connectItem,
    newConversation: newConversation,
    addConversationParticipant: addConversationParticipant,
    sendConversationInvite: sendConversationInvite,
    acceptConversationInvite: acceptConversationInvite,
    loadConversations: loadConversations,
    loadConversationParticipants: loadConversationParticipants,
    loadConversationInvites: loadConversationInvites,
    subscribeConversationMessageStream: subscribeConversationMessageStream,
    unsubscribeFromMessageStream: unsubscribeFromMessageStream,
    sendConversationMessage: sendConversationMessage,
    loadConversationMessages: loadConversationMessages,
    loadConversationItems: loadConversationItems,
    createConversationItem: createConversationItem,
    deleteConversationItem: deleteConversationItem,
    saveConversationItemData: saveConversationItemData,
    newRTCSession: newRTCSession,
    getRTCSession: getRTCSession,
    joinRTCSession: joinRTCSession,
    negotiateRTCSession: negotiateRTCSession
  },
  getters: {
    loggedInUser: loggedInUser,
    userExists: () => userExists,
    connections: connections,
    invites: invites,
    conversations: conversations,
    conversationMessages: conversationMessages,
    conversationParticipants: conversationParticipants,
    conversationItems: conversationItems,
    conversationInvites: conversationInvites,
    conversationRTCMessage: conversationRTCMessage,
    rtcSession: rtcSession
  }
}
